import { useState } from "react";
import { useParams } from "react-router-dom";
import API_ROUTES from "~/api-routes";
import apiService from "~/services/service";

const useEntityPlusForm = () => {
  const { id } = useParams();
  const [isEdit, setIsEdit] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (key, e, entityPlusData, setEntityPlusData) => {
    setEntityPlusData({ ...entityPlusData, [key]: e });
  };

  const handleEditClick = () => {
    setIsEdit(true);
    setSuccessMessage("");
  };

  const handleSaveClick = async (entityPlusData) => {
    setIsLoading(true);
    const data = await apiService(API_ROUTES.UPDATE_ENTITY_PLUS, "PUT", {
      replace: { id },
      body: JSON.stringify(entityPlusData),
    });
    setIsLoading(false);
    setIsEdit(false);
    setSuccessMessage("Entity Plus information has been Updated.");
  };

  return {
    handleInputChange,
    isEdit,
    setIsEdit,
    handleEditClick,
    handleSaveClick,
    successMessage,
    setSuccessMessage,
    isLoading,
  };
};

export default useEntityPlusForm;
